import { BASE_URL } from '../API/BASE_URL';

export const getArchives = async () => {
  const response = await fetch(BASE_URL + 'exhibitions/', {
    method: 'GET',
  });

  const data = await response.json();

  return data;
};
